export const SET_MENU = "SET_MENU";
export const SET_FILTER_GROUP = "SET_FILTER_GROUP";
export const SET_SHOW_FILTER_MENU = "SET_SHOW_FILTER_MENU";
export const RESET_FILTERS_SELECTED = "RESET_FILTERS_SELECTED";
export const TOGGLE_FILTERS_SELECTED = "TOGGLE_FILTERS_SELECTED";
